import { useEffect, useState } from 'react'
import { beobachteFassung } from '@/lib/build'
import './updatehint.css'

/**
 * Hinweis am unteren Rand, sobald eine neue Fassung ausgeliefert wurde.
 *
 * Bewusst kein automatisches Neuladen: Wer gerade eine Pose von Hand gesetzt
 * oder einen Merkzettel gefuellt hat, verliert das beim Neuladen. Der
 * Zeitpunkt gehoert deshalb dem Benutzer.
 */
export function UpdateHint() {
  const [neu, setNeu] = useState(false)
  const [weg, setWeg] = useState(false)

  useEffect(() => beobachteFassung(() => setNeu(true)), [])

  if (!neu || weg) return null

  return (
    <div className="uphint" role="status">
      <span className="uphint__text">Seite wurde aktualisiert</span>
      <button type="button" className="uphint__go" onClick={() => location.reload()}>
        Neu laden
      </button>
      <button
        type="button"
        className="uphint__off"
        aria-label="Hinweis schliessen"
        onClick={() => setWeg(true)}
      >
        ×
      </button>
    </div>
  )
}
